class Grid3columBlogElement extends HTMLElement {
  connectedCallback() {
    this.initCarousel();
    this.initVideoObserver();
    this.initLoadMore();
    this.initVideoControls();
  }

  initVideoObserver() {
    const videos = /** @type {HTMLVideoElement[]} */ (
      Array.from(this.querySelectorAll('.c-grid-3colum-blog__video'))
    );

    videos.forEach((video) => {
      video.removeAttribute('autoplay');
      video.pause();
    });
  }

  initCarousel() {
    if (this.dataset.mobileLayout !== 'carousel') {
      return;
    }

    const track = this.querySelector('[data-mobile-carousel-track]');
    const prevBtn = this.querySelector('[data-carousel-prev]');
    const nextBtn = this.querySelector('[data-carousel-next]');

    if (!(track instanceof HTMLElement)) {
      return;
    }

    if (
      prevBtn instanceof HTMLButtonElement &&
      nextBtn instanceof HTMLButtonElement &&
      prevBtn.dataset.arrowsBound !== 'true'
    ) {
      prevBtn.dataset.arrowsBound = 'true';

      const updateArrows = () => {
        const maxScroll = track.scrollWidth - track.clientWidth;
        prevBtn.disabled = track.scrollLeft <= 1;
        nextBtn.disabled = track.scrollLeft >= maxScroll - 1;
      };

      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -track.clientWidth * 0.9, behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: track.clientWidth * 0.9, behavior: 'smooth' });
      });
      track.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();
    }

    if (track.dataset.carouselBound === 'true') {
      return;
    }

    track.dataset.carouselBound = 'true';

    /** @type {HTMLElement[]} */
    const items = Array.from(track.querySelectorAll('.c-grid-3colum-blog__item')).filter(
      (item) => item instanceof HTMLElement && window.getComputedStyle(item).display !== 'none'
    ).map((item) => /** @type {HTMLElement} */ (item));

    if (items.length <= 1) {
      return;
    }

    if (window.matchMedia('(max-width: 767px)').matches) {
      const initialIndex = items.length >= 3 ? 1 : 0;
      const initialItem = items[initialIndex];
      if (initialItem instanceof HTMLElement) {
        const centeredScroll = initialItem.offsetLeft - (track.clientWidth - initialItem.clientWidth) / 2;
        track.scrollLeft = centeredScroll;
      }
    }
  }

  initVideoControls() {
    this.querySelectorAll('.c-grid-3colum-blog__media-wrap').forEach((wrap) => {
      const video = /** @type {HTMLVideoElement|null} */ (wrap.querySelector('video'));
      const playBtn = wrap.querySelector('[data-grid-play-btn]');
      const soundBtn = wrap.querySelector('[data-grid-sound-btn]');
      if (!video || !playBtn) return;

      playBtn.addEventListener('click', () => {
        if (video.paused) { video.play(); } else { video.pause(); }
      });
      video.addEventListener('play', () => {
        playBtn.classList.add('is-playing');
        playBtn.setAttribute('aria-label', 'Pause video');
      });
      video.addEventListener('pause', () => {
        playBtn.classList.remove('is-playing');
        playBtn.setAttribute('aria-label', 'Play video');
      });
      if (soundBtn) {
        soundBtn.addEventListener('click', () => {
          video.muted = !video.muted;
          soundBtn.classList.toggle('is-muted', video.muted);
          soundBtn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
        });
      }
    });
  }

  initLoadMore() {
    const btn = this.querySelector('[data-load-more-btn]');
    if (!btn) return;

    this._loadMoreExpanded = false;

    btn.addEventListener('click', () => {
      if (this._loadMoreExpanded) {
        this._collapseExtra(/** @type {HTMLElement} */ (btn));
      } else {
        this._expandExtra(/** @type {HTMLElement} */ (btn));
      }
      this._loadMoreExpanded = !this._loadMoreExpanded;
    });
  }

  /** @param {HTMLElement} btn */
  _expandExtra(btn) {
    const cards = /** @type {HTMLElement[]} */ (
      Array.from(this.querySelectorAll('[data-load-more-hidden]'))
    );

    cards.forEach((card, i) => {
      card.removeAttribute('data-load-more-hidden');
      card.classList.remove('is-hiding');
      card.classList.add('is-revealing');
      card.style.animationDelay = `${i * 50}ms`;
      card.addEventListener('animationend', () => {
        card.classList.remove('is-revealing');
        card.style.animationDelay = '';
      }, { once: true });
    });

    btn.textContent = 'SHOW LESS';

    if (this.dataset.mobileLayout === 'carousel') {
      setTimeout(() => this._refreshCarousel(), cards.length * 50 + 420);
    }
  }

  /** @param {HTMLElement} btn */
  _collapseExtra(btn) {
    const extra = /** @type {HTMLElement[]} */ (
      Array.from(this.querySelectorAll('.c-grid-3colum-blog__item')).slice(6)
    );
    if (!extra.length) return;

    extra.forEach((card) => {
      card.classList.remove('is-revealing');
      card.classList.add('is-hiding');
      card.style.animationDelay = '';
    });

    setTimeout(() => {
      extra.forEach((card) => {
        card.classList.remove('is-hiding');
        card.setAttribute('data-load-more-hidden', '');
      });
      if (this.dataset.mobileLayout === 'carousel') this._refreshCarousel();
    }, 350);

    btn.textContent = 'LOAD MORE';
  }

  _refreshCarousel() {
    const track = this.querySelector('[data-mobile-carousel-track]');
    if (track instanceof HTMLElement) delete track.dataset.carouselBound;
    this.initCarousel();
  }
}

if (!customElements.get('grid-3colum-blog')) {
  customElements.define('grid-3colum-blog', Grid3columBlogElement);
}
